import { render, staticRenderFns } from "./demo-access-view.vue?vue&type=template&id=7c4de144&"
import script from "./demo-access-view.vue?vue&type=script&lang=js&"
export * from "./demo-access-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports